import React, { FC, useEffect, useRef, useState } from 'react'
import { FileTableRowProps } from '../../Abbreviations/tableRow/types'
import * as Styles from '../../Abbreviations/tableRow/cells/definition/styles'
import { knowledgeFileService } from '../../../api/knowledgeFile'
import { alertError } from 'api'

export const DescriptionTableRowCell: FC<FileTableRowProps> = ({ source, updateSource, onBlurHandle }) => {
  const [description, setDescription] = useState<string>(source.description)
  const [isEditMode, setIsEditMode] = useState<boolean>(false)
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (isEditMode && inputRef.current) inputRef.current.focus()
  }, [isEditMode])

  const openEditWindow = () => {
    setIsEditMode(true)
  }

  const textAreaChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setDescription(event.target.value)
  }

  const onBlurEvent = () => {
    setIsEditMode(false)
    if (description.trim().length > 0) {
      if (source.description !== description) {
        source.description = description
        knowledgeFileService
          .updateKnowledgeFile({ _id: source._id, description: source.description, type: source.type })
          .then(response => updateSource(response))
          .catch(error => {
            alertError(error?.message || 'Something went wrong')
          })
      }
    } else {
      setDescription(source.description)
      alertError('Description must not be empty or consist only of spaces')
    }
  }

  const customOnBlur = () => {
    setIsEditMode(false)
    onBlurHandle(source._id, description)
  }

  return (
    <Styles.DefinitionContainer>
      {isEditMode && (
        <Styles.DefinitionEditBlock>
          <Styles.DefinitionTextArea
            value={description}
            onChange={textAreaChange}
            onBlur={onBlurHandle ? customOnBlur : onBlurEvent}
            ref={inputRef}
          />
        </Styles.DefinitionEditBlock>
      )}
      {source.description ? (
        <Styles.AnswerText onClick={openEditWindow}>{source.description}</Styles.AnswerText>
      ) : (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Styles.DefinitionAddButton onClick={openEditWindow}>Add description</Styles.DefinitionAddButton>
          <label style={{ margin: 0, color: '#6c757d', fontSize: '12px', cursor: 'default' }}>
            Description is required!
          </label>
        </div>
      )}
    </Styles.DefinitionContainer>
  )
}
